export const removeEmail = (name: string, email: string): string => {
  return name?.replace(` (${email})`, "") || "";
};
